import { realApi } from './api';

// public/version.json lo genera scripts/generate-version.js en el prebuild:
// versión y commit con los que se generó ESTE build (front), no una
// versión abstracta de package.json. En desarrollo no existe (el prebuild
// solo corre antes de `npm run build`), así que el fetch falla y se
// resuelve como null.
export const getVersionFrontend = () =>
  fetch(`${process.env.PUBLIC_URL}/version.json?v=${Date.now()}`, { cache: 'no-store' })
    .then((res) => (res.ok ? res.json() : null))
    .catch(() => null);

// /salud es un endpoint de infraestructura aparte del resto de la API real:
// no usa el formato {datos,total}/{error,codigo} de las demás rutas.
export const getVersionBackend = () =>
  realApi.get('/salud').catch(() => null);
